module.exports = __webpack_public_path__ + "img/Psyhic-J-4.d921b147.svg";